import React from 'react';

import Trading from '../features/trading/Trading';

const Index: React.FC = () => <Trading />;

Index.displayName = 'Index';
export default Index;
